<div class="flex flex-col gap-6 animate-fade-in">

  <!-- Header -->
  <div class="app-header">
    <div class="app-header__title">
      <svg class="app-header__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
      </svg>
      <div>
        <h1 class="app-header__headline">Connected Applications</h1>
        <p class="app-header__sub">Register and manage applications using the API.</p>
      </div>
    </div>
    
    <div class="flex gap-2">
      <button (click)="loadApps()" class="flex items-center gap-2 px-4 py-2 rounded-lg border border-[#ffffff10] bg-[#ffffff05] hover:bg-[rgba(18,24,52,0.92)] hover:border-[rgba(80,110,247,0.55)] hover:shadow-[0_0_16px_rgba(80,110,247,0.28)] hover:-translate-y-px text-[var(--text-muted)] hover:text-white font-medium transition-all duration-150 cursor-pointer">
        <svg class="w-4 h-4 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
      </button>
      @if (canCreateApp()) {
      <button (click)="openCreateModal()" class="flex items-center gap-2 px-4 py-2 rounded-lg border border-[#ffffff10] bg-[#ffffff05] hover:bg-[rgba(18,24,52,0.92)] hover:border-[rgba(80,110,247,0.55)] hover:shadow-[0_0_16px_rgba(80,110,247,0.28)] hover:-translate-y-px text-white font-semibold transition-all duration-150 cursor-pointer">
        <svg class="w-5 h-5 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg>
        Register App
      </button>
      }
    </div>
  </div>

  <div class="app-filter" (click)="$event.stopPropagation()">
    <button type="button" id="app-status-filter" class="app-filter__select"
      aria-label="Filter apps" aria-haspopup="listbox" [attr.aria-expanded]="filterOpen()"
      (click)="toggleFilterMenu()">
      <span>{{ currentFilterLabel() }}</span>
      <svg class="app-filter__chevron" [class.app-filter__chevron--open]="filterOpen() && !filterClosing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
      </svg>
    </button>
    @if (filterOpen()) {
      <div class="app-filter__menu" [class.app-filter__menu--closing]="filterClosing()" role="listbox" aria-labelledby="app-status-filter">
        <button type="button" class="app-filter__option" role="option" [attr.aria-selected]="activeFilter() === 'all'" [class.app-filter__option--active]="activeFilter() === 'all'" (click)="chooseFilter('all')">All Apps ({{ displayAllCount() }})</button>
        <button type="button" class="app-filter__option" role="option" [attr.aria-selected]="activeFilter() === 'active'" [class.app-filter__option--active]="activeFilter() === 'active'" (click)="chooseFilter('active')">Active ({{ displayActiveCount() }})</button>
        <button type="button" class="app-filter__option" role="option" [attr.aria-selected]="activeFilter() === 'inactive'" [class.app-filter__option--active]="activeFilter() === 'inactive'" (click)="chooseFilter('inactive')">Inactive ({{ displayInactiveCount() }})</button>
      </div>
    }
  </div>
  
  <!-- Error banner -->
  @if (errorMsg()) {
    <div class="px-4 py-3 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 text-sm flex items-center gap-2">
      <svg class="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      {{ errorMsg() }}
    </div>
  }
  
  <div class="app-results">
  @for (filter of [activeFilter()]; track filter) {
  <div class="app-results__stage" animate.enter="app-results-fade-in" (animate.leave)="fadeResults($event)">
  <!-- Loading state -->
  @if (isLoading()) {
    <div class="flex items-center justify-center py-16 gap-3 text-[var(--text-muted)]">
      <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      Loading apps…
    </div>
  }

  <!-- Empty state -->
  @if (!isLoading() && apps().length === 0) {
    <div class="flex flex-col items-center justify-center py-16 bg-[var(--bg-panel)] border border-[#ffffff10] rounded-xl shadow-lg shadow-black/20 text-[var(--text-muted)]">
      <svg class="w-12 h-12 mb-4 opacity-40 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
      </svg>
      <p class="text-sm">No applications found.</p>
      @if (canCreateApp()) {
        <button (click)="openCreateModal()" class="mt-4 text-[#506ef7] text-sm hover:underline font-medium">Register your first app</button>
      }
    </div>
  }

  <!-- Grid -->
  @if (!isLoading() && apps().length > 0) {
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2">
      @for (app of apps(); track app.id; let last = $last) {
        <div class="app-card bg-[var(--bg-panel)] border border-[#ffffff10] rounded-xl p-5 sm:p-6 group flex flex-col sm:flex-row gap-5 cursor-pointer"
             (click)="openManageModal(app)">
          
          <div class="flex-shrink-0 flex items-start gap-4">
            <div class="app-card__icon w-14 h-14 rounded-xl flex items-center justify-center bg-gradient-to-br {{ getAppGradient(app.app_id) }} shadow-md relative overflow-hidden min-w-[56px]">
              @if (app.app_icon) {
                <img [src]="app.app_icon" class="w-full h-full object-cover">
              } @else {
                <span class="text-white font-bold text-xl">{{ app.app_name.substring(0, 1).toUpperCase() }}</span>
              }
            </div>
          </div>

          <div class="flex-1 flex flex-col justify-between min-w-0">
            <div class="flex justify-between items-start">
              <div class="min-w-0 pr-4">
                <div class="flex items-center gap-2 mb-1">
                  <h3 class="text-lg font-semibold text-white truncate" [title]="app.app_name">{{ app.app_name }}</h3>
                  <span class="px-2 py-0.5 rounded text-[10px] font-bold tracking-wider uppercase border"
                    [class]="app.is_active ? 'bg-green-500/10 text-green-400 border-green-500/20' : 'bg-gray-500/10 text-gray-400 border-gray-500/20'">
                    {{ app.is_active ? 'ACTIVE' : 'INACTIVE' }}
                  </span>
                </div>
                <div class="text-[10px] text-[var(--text-muted)] font-mono truncate">ID: {{ app.app_id }}</div>
              </div>
            </div>

            <div class="mt-4 pt-4 border-t border-[#ffffff10] flex flex-wrap gap-6 text-sm">
              @if (canManageCreators()) {
              <div class="flex flex-col gap-1">
                <span class="text-xs text-[var(--text-muted)] font-medium uppercase tracking-wider">Editors</span>
                <span class="text-white font-medium flex items-center gap-1.5">
                  <svg class="w-4 h-4 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
                  {{ (app.content_creators ?? []).length }} Linked
                </span>
              </div>
              }
              <div class="flex flex-col gap-1">
                <span class="text-xs text-[var(--text-muted)] font-medium uppercase tracking-wider">Website</span>
                <span class="text-white font-medium truncate max-w-[150px]">
                  @if (app.website_url) {
                    <a [href]="app.website_url" target="_blank" class="hover:text-[#506ef7] transition-colors flex items-center gap-1" (click)="$event.stopPropagation()">
                      {{ app.website_url }}
                      <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>
                    </a>
                  } @else {
                    <span class="text-gray-500 italic">Not specified</span>
                  }
                </span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="text-xs text-[var(--text-muted)] font-medium uppercase tracking-wider">Platform</span>
                <span class="text-white font-medium truncate max-w-[150px]">
                  {{ app.platform ?? '—' }}
                </span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="text-xs text-[var(--text-muted)] font-medium uppercase tracking-wider">Category</span>
                <span class="text-white font-medium truncate max-w-[150px]">
                  {{ app.category ?? '—' }}
                </span>
              </div>
            </div>
            
          </div>
        </div>
      }
    </div>
  }
  </div>
  }
  </div>
</div>

<!-- ======================================================================= -->
<!-- MANAGE APP MODAL (single screen: settings + creators + delete)           -->
<!-- ======================================================================= -->
@if (showManageModal()) {
  <div class="modal-backdrop" [class.app-modal-backdrop--closing]="manageClosing()" (click)="closeManageModal()">
    <div class="modal-panel modal-panel--xl" [class.app-modal-panel--closing]="manageClosing()" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          <svg class="w-5 h-5 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
          </svg>
          <span class="truncate">{{ selectedApp()?.app_name }}</span>
        </h3>
        <div class="flex items-center gap-1">
          @if (canUpdateApp()) {
          <button type="button"
                  class="modal-close-btn modal-close-btn--danger"
                  title="Delete"
                  (click)="openDangerZone()">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
          }
          <button class="modal-close-btn" (click)="closeManageModal()">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </div>
      </div>

      <div class="modal-body !pt-4">
        <!-- Top summary row -->
        <div class="flex items-start gap-4">
          <div class="w-14 h-14 rounded-xl overflow-hidden border border-[#ffffff10] bg-[#ffffff05] flex items-center justify-center flex-shrink-0">
            @if (pendingIconPreviewUrl()) {
              <img [src]="pendingIconPreviewUrl()!" class="w-full h-full object-cover" alt="App icon preview">
            } @else if (selectedApp()?.app_icon) {
              <img [src]="selectedApp()!.app_icon!" class="w-full h-full object-cover" alt="Current app icon">
            } @else {
              <span class="text-white font-bold text-xl">
                {{ (selectedApp()?.app_name ?? '').substring(0, 1).toUpperCase() }}
              </span>
            }
          </div>
          <div class="min-w-0 flex-1">
            <div class="flex items-center justify-between gap-3">
              <div class="min-w-0">
                <div class="text-sm font-semibold text-white truncate">{{ selectedApp()?.app_name }}</div>
                <div class="text-xs text-[var(--text-muted)] font-mono truncate">ID: {{ selectedApp()?.app_id }}</div>
              </div>
              <div class="flex gap-2 flex-wrap justify-end">
                @if (canUpdateApp()) {
                <input id="manage-app-icon" type="file" class="hidden" accept="image/png, image/jpeg, image/gif" (change)="onModalIconSelected($event)">
                <label for="manage-app-icon" class="btn-ghost px-3 py-2 text-sm inline-flex items-center gap-2 cursor-pointer">
                  Change icon
                </label>
                @if (pendingIconFile()) {
                  <button type="button" class="btn-ghost px-3 py-2 text-sm" (click)="setPendingIcon(null)">Clear</button>
                }
                }
              </div>
            </div>
            <div class="mt-2 flex flex-wrap gap-2">
              <span class="px-2 py-1 rounded-md bg-[#ffffff05] border border-[#ffffff10] text-xs text-[var(--text-muted)]">
                Platform: <span class="text-white">{{ selectedApp()?.platform ?? '—' }}</span>
              </span>
              <span class="px-2 py-1 rounded-md bg-[#ffffff05] border border-[#ffffff10] text-xs text-[var(--text-muted)]">
                Category: <span class="text-white">{{ selectedApp()?.category ?? '—' }}</span>
              </span>
              @if (canManageCreators()) {
              <span class="px-2 py-1 rounded-md bg-[#ffffff05] border border-[#ffffff10] text-xs text-[var(--text-muted)]">
                Editors: <span class="text-white">{{ (isLoadingCreators() ? (selectedApp()?.content_creators ?? []) : appCreators()).length }}</span>
              </span>
              }
            </div>
          </div>
        </div>

        @if (saveError()) {
          <div class="alert-error mt-4">{{ saveError() }}</div>
        }
        @if (saveSuccess()) {
          <div class="alert-success mt-4">{{ saveSuccess() }}</div>
        }

        <!-- Two-column layout -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
          <!-- Settings -->
          <div class="border border-[#ffffff10] rounded-xl overflow-hidden">
            <div class="px-4 py-3 border-b border-[#ffffff10] bg-[#ffffff02]">
              <div class="text-sm font-semibold text-white">App Settings</div>
              <div class="text-xs text-[var(--text-muted)] mt-0.5">@if (canUpdateApp()) { Edit app details and save changes. } @else { App details (read-only). }</div>
            </div>
            <div class="p-4">
              <form [formGroup]="appForm" class="flex flex-col gap-4">
                <div class="form-group">
                  <label class="form-label">Application Name *</label>
                  <input formControlName="app_name" type="text" class="form-input"
                         [class.border-red-500]="appForm.get('app_name')?.invalid && appForm.get('app_name')?.touched">
                  @if (appForm.get('app_name')?.invalid && appForm.get('app_name')?.touched) {
                    <span class="form-error">App Name is required</span>
                  }
                </div>

                <div class="form-group">
                  <label class="form-label">Website URL (Optional)</label>
                  <input formControlName="website_url" type="url" class="form-input" placeholder="https://myapp.example.com">
                </div>

                <div class="form-group">
                  <label class="form-label">Platform *</label>
                  <div class="flex gap-2 flex-wrap">
                    <button type="button"
                            class="px-4 py-2 rounded-lg border text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 disabled:pointer-events-none"
                            [class]="isPlatform('ios') ? 'bg-[#506ef7]/15 text-white border-[#506ef7]/40' : 'bg-[#ffffff05] text-[var(--text-muted)] border-[#ffffff10] hover:bg-[#ffffff10] hover:text-white'"
                            [disabled]="!canUpdateApp()"
                            (click)="setPlatform('ios')">
                      iOS
                    </button>
                    <button type="button"
                            class="px-4 py-2 rounded-lg border text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 disabled:pointer-events-none"
                            [class]="isPlatform('both') ? 'bg-[#506ef7]/15 text-white border-[#506ef7]/40' : 'bg-[#ffffff05] text-[var(--text-muted)] border-[#ffffff10] hover:bg-[#ffffff10] hover:text-white'"
                            [disabled]="!canUpdateApp()"
                            (click)="setPlatform('both')">
                      Both
                    </button>
                    <button type="button"
                            class="px-4 py-2 rounded-lg border text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 disabled:pointer-events-none"
                            [class]="isPlatform('android') ? 'bg-[#506ef7]/15 text-white border-[#506ef7]/40' : 'bg-[#ffffff05] text-[var(--text-muted)] border-[#ffffff10] hover:bg-[#ffffff10] hover:text-white'"
                            [disabled]="!canUpdateApp()"
                            (click)="setPlatform('android')">
                      Android
                    </button>
                  </div>
                  @if (appForm.get('platform')?.invalid && appForm.get('platform')?.touched) {
                    <span class="form-error">Platform is required</span>
                  }
                </div>

                @if (appForm.value.platform === 'ios' || appForm.value.platform === 'both') {
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div class="form-group">
                      <label class="form-label">Bundle ID (Optional)</label>
                      <input formControlName="bundle_id" type="text" class="form-input" placeholder="com.company.app">
                    </div>
                    <div class="form-group">
                      <label class="form-label">App Store ID (Optional)</label>
                      <input formControlName="app_store_id" type="text" class="form-input" placeholder="e.g. 1234567890">
                    </div>
                  </div>
                }

                @if (appForm.value.platform === 'android' || appForm.value.platform === 'both') {
                  <div class="form-group">
                    <label class="form-label">Play Store ID (Optional)</label>
                    <input formControlName="play_store_id" type="text" class="form-input" placeholder="com.company.app">
                  </div>
                }

                <div class="form-group">
                  <label class="form-label">Store Category (Optional)</label>
                  <select formControlName="category" class="form-input">
                    <option value="">Select category…</option>
                    @for (cat of storeCategories; track cat) {
                      <option [value]="cat">{{ cat }}</option>
                    }
                  </select>
                </div>
              </form>
            </div>
          </div>

          <!-- Creators -->
          <div class="border border-[#ffffff10] rounded-xl overflow-hidden">
            <div class="px-4 py-3 border-b border-[#ffffff10] bg-[#ffffff02]">
              <div class="text-sm font-semibold text-white">Content Editors</div>
              <div class="text-xs text-[var(--text-muted)] mt-0.5">@if (canManageCreators()) { Link or remove content editors for this app. } @else { Only Admin or Super Admin can view this section. }</div>
            </div>
            <div class="p-4">
              @if (canManageCreators()) {
              <form [formGroup]="creatorForm" (ngSubmit)="addCreator()" class="flex flex-col sm:flex-row gap-3">
                <div class="flex-1 min-w-0 flex flex-col pt-1">
                  <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg class="h-4 w-4 text-[var(--text-muted)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                      </svg>
                    </div>
                    <input formControlName="email" type="email" placeholder="editor@example.com" class="form-input form-input--with-icon-left h-10 w-full bg-[#ffffff05]"
                          [class.border-red-500]="creatorForm.get('email')?.invalid && creatorForm.get('email')?.touched">
                  </div>
                  @if (creatorForm.get('email')?.invalid && creatorForm.get('email')?.touched) {
                    <span class="form-error mt-1 text-xs">Valid email required</span>
                  }
                </div>
                <button type="submit" class="btn-primary whitespace-nowrap h-10 px-4 pt-2 -mt-0" [disabled]="isSaving()">
                  @if (isSaving()) {
                    <svg class="animate-spin w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
                    Linking...
                  } @else {
                    Link
                  }
                </button>
              </form>

              <div class="mt-4">
                @if (isLoadingCreators()) {
                  <div class="flex items-center justify-center py-8 text-[var(--text-muted)] text-sm">
                    <svg class="animate-spin w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
                    Loading editors...
                  </div>
                } @else if (appCreators().length === 0) {
                  <div class="text-center py-8 text-[var(--text-muted)] bg-[#ffffff02] border border-[#ffffff05] rounded-lg border-dashed">
                    <p class="text-xs">No editors linked yet.</p>
                  </div>
                } @else {
                  <div class="flex flex-col gap-2">
                    @for (creator of appCreators(); track creator.user_id) {
                      <div class="flex items-center justify-between p-3 rounded-lg border border-[#ffffff08] bg-[#ffffff03] hover:bg-[#ffffff05] transition-colors group">
                        <div class="flex items-center gap-3 min-w-0">
                          <div class="w-8 h-8 rounded-full bg-[#506ef7]/20 border border-[#506ef7]/30 flex items-center justify-center text-[#506ef7] font-semibold text-xs flex-shrink-0">
                            @if (canSeeOtherUsers() && appCreatorUsers()[creator.user_id]) {
                              {{ (appCreatorUsers()[creator.user_id].first_name?.charAt(0) ?? '') + (appCreatorUsers()[creator.user_id].last_name?.charAt(0) ?? '') || '?' }}
                            } @else {
                              ?
                            }
                          </div>
                          <div class="min-w-0">
                            <div class="text-sm font-medium text-white truncate">
                              @if (canSeeOtherUsers() && appCreatorUsers()[creator.user_id]) {
                                {{ (appCreatorUsers()[creator.user_id].first_name ?? '') + ' ' + (appCreatorUsers()[creator.user_id].last_name ?? '') }}
                              } @else {
                                Linked editor
                              }
                            </div>
                            <div class="text-xs text-[var(--text-muted)] truncate">
                              @if (canSeeOtherUsers() && appCreatorUsers()[creator.user_id]) {
                                {{ appCreatorUsers()[creator.user_id].email }}
                              } @else {
                                —
                              }
                            </div>
                          </div>
                        </div>
                        @if (canManageCreators()) {
                        <button type="button" (click)="removeCreator(creator.user_id)" [disabled]="isSaving()"
                                class="p-1.5 text-[var(--text-muted)] hover:text-red-400 hover:bg-red-400/10 rounded-md transition-colors flex-shrink-0 disabled:opacity-50"
                                title="Remove Link">
                          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                        </button>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
              } @else {
              <div class="py-10 px-4 text-center rounded-lg bg-[#ffffff03] border border-[#ffffff08]">
                <svg class="w-12 h-12 mx-auto mb-3 text-[var(--text-muted)] opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
                <p class="text-sm font-medium text-white">Sorry, you cannot see this feature.</p>
                <p class="text-xs text-[var(--text-muted)] mt-1.5 max-w-xs mx-auto">Content editor list and management are only available to Admin and Super Admin roles.</p>
              </div>
              }
            </div>
          </div>
        </div>

        @if (canUpdateApp() && isDangerZoneOpen()) {
          <div class="mt-3 p-4 rounded-xl border border-red-500/25 bg-red-500/5">
            <div class="flex items-start justify-between gap-3">
              <div>
                <div class="text-sm font-semibold text-red-200">Danger zone</div>
                <p class="text-sm text-[var(--text-muted)] mt-2">
                  Permanently delete <strong class="text-white">{{ selectedApp()?.app_name }}</strong>. This action cannot be undone.
                </p>
              </div>
              <button type="button" class="modal-close-btn" (click)="closeDangerZone()" [disabled]="isSaving()" title="Close danger zone" aria-label="Close danger zone">
                <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
              </button>
            </div>

            <div class="mt-3">
              <label class="block text-xs font-medium text-[var(--text-muted)] mb-1.5">
                Type <span class="text-red-200 font-semibold">delete</span> to enable deletion
              </label>
              <input type="text"
                     [ngModel]="deleteConfirmText()" (ngModelChange)="deleteConfirmText.set($event)"
                     placeholder="delete"
                     class="w-full px-4 py-2.5 bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-red-500/60 focus:ring-1 focus:ring-red-500/30 transition-all placeholder:text-[var(--text-muted)]">
            </div>

            <div class="mt-4 flex gap-2 flex-wrap justify-end">
              @if (!isDeleteConfirmStep()) {
                <button type="button"
                        class="btn-danger"
                        (click)="startDeleteConfirm()"
                        [disabled]="isSaving() || deleteConfirmText().trim().toLowerCase() !== 'delete'">
                  Delete App
                </button>
              } @else {
                <div class="flex items-center gap-2 flex-wrap justify-end w-full sm:w-auto">
                  <span class="text-xs text-red-200 mr-auto sm:mr-0">Are you sure?</span>
                  <button type="button" class="btn-ghost" (click)="cancelDeleteConfirm()" [disabled]="isSaving()">Cancel</button>
                  <button type="button" class="btn-danger" (click)="deleteSelectedApp()" [disabled]="isSaving()">Confirm Delete</button>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="modal-footer">
        @if (canUpdateApp()) {
        <button type="button" class="btn-primary justify-center" (click)="saveManageSettings()" [disabled]="isSaving() || !hasManageFormChanges()">
          @if (isSaving()) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            Saving…
          } @else {
            Save Changes
          }
        </button>
        } @else {
        <button type="button" class="btn-ghost" (click)="closeManageModal()">Close</button>
        }
      </div>
    </div>
  </div>
}

<!-- ======================================================================= -->
<!-- CREATE / EDIT APP MODAL                                                 -->
<!-- ======================================================================= -->
@if (showCreateModal() || showEditModal()) {
  <div class="modal-backdrop" [class.app-modal-backdrop--closing]="appModalClosing()" (click)="closeAppModal()">
    <div class="modal-panel" [class.app-modal-panel--closing]="appModalClosing()" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          <svg class="w-5 h-5 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
          </svg>
          {{ showEditModal() ? 'Edit Application' : 'Register New Application' }}
        </h3>
        <button class="modal-close-btn" (click)="closeAppModal()">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <form [formGroup]="appForm" (ngSubmit)="submitAppForm()" class="modal-body">
        <div class="flex items-start gap-4">
          <div class="w-14 h-14 rounded-xl overflow-hidden border border-[#ffffff10] bg-[#ffffff05] flex items-center justify-center flex-shrink-0">
            @if (pendingIconPreviewUrl()) {
              <img [src]="pendingIconPreviewUrl()!" class="w-full h-full object-cover" alt="App icon preview">
            } @else if (showEditModal() && selectedApp()?.app_icon) {
              <img [src]="selectedApp()!.app_icon!" class="w-full h-full object-cover" alt="Current app icon">
            } @else {
              <svg class="w-6 h-6 text-[#ffffff35]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 16A2 2 0 005 18H19A2 2 0 0021 16V8A2 2 0 0019 6H5A2 2 0 003 8v8z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 11v3"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14h6"/>
              </svg>
            }
          </div>
          <div class="min-w-0">
            <div class="text-sm font-semibold text-white">App Icon (Optional)</div>
            <div class="text-xs text-[var(--text-muted)] mt-0.5">PNG/JPG/GIF. If selected, it will be uploaded after saving.</div>
            <div class="mt-2 flex gap-2 flex-wrap">
              <input id="modal-app-icon" type="file" class="hidden" accept="image/png, image/jpeg, image/gif" (change)="onModalIconSelected($event)">
              <label for="modal-app-icon" class="btn-ghost px-3 py-2 text-sm inline-flex items-center gap-2 cursor-pointer">
                Choose file
              </label>
              @if (pendingIconFile()) {
                <button type="button" class="btn-ghost px-3 py-2 text-sm" (click)="setPendingIcon(null)">Clear</button>
              }
            </div>
          </div>
        </div>
        
        <div class="form-group mb-4">
          <label class="form-label">Application Name *</label>
          <input formControlName="app_name" type="text" placeholder="e.g. Content Publisher Pro" class="form-input"
                 [class.border-red-500]="appForm.get('app_name')?.invalid && appForm.get('app_name')?.touched">
          @if (appForm.get('app_name')?.invalid && appForm.get('app_name')?.touched) {
            <span class="form-error">App Name is required</span>
          }
        </div>
        
        <div class="form-group">
          <label class="form-label">Website URL (Optional)</label>
          <input formControlName="website_url" type="url" placeholder="https://myapp.example.com" class="form-input">
        </div>

        <div class="form-group">
          <label class="form-label">Platform *</label>
          <div class="flex gap-2">
            <button type="button"
                    class="px-4 py-2 rounded-lg border text-sm font-medium transition-colors"
                    [class]="isPlatform('ios') ? 'bg-[#506ef7]/15 text-white border-[#506ef7]/40' : 'bg-[#ffffff05] text-[var(--text-muted)] border-[#ffffff10] hover:bg-[#ffffff10] hover:text-white'"
                    (click)="setPlatform('ios')">
              iOS
            </button>
            <button type="button"
                    class="px-4 py-2 rounded-lg border text-sm font-medium transition-colors"
                    [class]="isPlatform('both') ? 'bg-[#506ef7]/15 text-white border-[#506ef7]/40' : 'bg-[#ffffff05] text-[var(--text-muted)] border-[#ffffff10] hover:bg-[#ffffff10] hover:text-white'"
                    (click)="setPlatform('both')">
              Both
            </button>
            <button type="button"
                    class="px-4 py-2 rounded-lg border text-sm font-medium transition-colors"
                    [class]="isPlatform('android') ? 'bg-[#506ef7]/15 text-white border-[#506ef7]/40' : 'bg-[#ffffff05] text-[var(--text-muted)] border-[#ffffff10] hover:bg-[#ffffff10] hover:text-white'"
                    (click)="setPlatform('android')">
              Android
            </button>
          </div>
          @if (appForm.get('platform')?.invalid && appForm.get('platform')?.touched) {
            <span class="form-error">Platform is required</span>
          }
        </div>

        @if (appForm.value.platform === 'ios' || appForm.value.platform === 'both') {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="form-group">
              <label class="form-label">Bundle ID (Optional)</label>
              <input formControlName="bundle_id" type="text" placeholder="com.company.app" class="form-input">
            </div>
            <div class="form-group">
              <label class="form-label">App Store ID (Optional)</label>
              <input formControlName="app_store_id" type="text" placeholder="e.g. 1234567890" class="form-input">
            </div>
          </div>
        }

        @if (appForm.value.platform === 'android' || appForm.value.platform === 'both') {
          <div class="form-group">
            <label class="form-label">Play Store ID (Optional)</label>
            <input formControlName="play_store_id" type="text" placeholder="com.company.app" class="form-input">
          </div>
        }

        <div class="form-group">
          <label class="form-label">Store Category (Optional)</label>
          <select formControlName="category" class="form-input">
            <option value="">Select category…</option>
            @for (cat of storeCategories; track cat) {
              <option [value]="cat">{{ cat }}</option>
            }
          </select>
        </div>

        @if (saveError()) {
          <div class="alert-error">{{ saveError() }}</div>
        }
        @if (saveSuccess()) {
          <div class="alert-success">{{ saveSuccess() }}</div>
        }
      </form>

      <div class="modal-footer">
        <button type="button" class="btn-ghost" (click)="closeAppModal()">Cancel</button>
        <button type="button" class="btn-primary" (click)="submitAppForm()" [disabled]="isSaving()">
          @if (isSaving()) {
            <svg class="animate-spin w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            Saving...
          } @else {
            {{ showEditModal() ? 'Save Changes' : 'Register App' }}
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- ======================================================================= -->
<!-- CONTENT CREATORS MODAL                                                  -->
<!-- ======================================================================= -->
@if (showCreatorsModal()) {
  <div class="modal-backdrop" (click)="closeCreatorsModal()">
    <div class="modal-panel modal-panel--lg" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          <svg class="w-5 h-5 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
          </svg>
          <span class="truncate">Linked Editors — {{ selectedApp()?.app_name }}</span>
        </h3>
        <button class="modal-close-btn" (click)="closeCreatorsModal()">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <div class="modal-body !p-0">
        @if (canManageCreators()) {
        <!-- Add new creator form -->
        <div class="p-4 sm:p-6 border-b border-[#ffffff10] bg-[#ffffff02]">
          <h4 class="text-sm font-semibold text-white mb-3">Link Content Editor</h4>
          <form [formGroup]="creatorForm" (ngSubmit)="addCreator()" class="flex flex-col sm:flex-row gap-3">
            <div class="flex-1 min-w-0 flex flex-col pt-1">
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg class="h-4 w-4 text-[var(--text-muted)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                  </svg>
                </div>
                <input formControlName="email" type="email" placeholder="editor@example.com" class="form-input form-input--with-icon-left h-10 w-full bg-[#ffffff05]"
                      [class.border-red-500]="creatorForm.get('email')?.invalid && creatorForm.get('email')?.touched">
              </div>
              @if (creatorForm.get('email')?.invalid && creatorForm.get('email')?.touched) {
                <span class="form-error mt-1 text-xs">Valid email required</span>
              }
            </div>
            
            <button type="submit" class="btn-primary whitespace-nowrap h-10 px-4 pt-2 -mt-0" [disabled]="isSaving()">
              @if (isSaving()) {
                <svg class="animate-spin w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
                Linking...
              } @else {
                <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/></svg>
                Link Editor
              }
            </button>
          </form>
          
          @if (saveError()) {
            <div class="alert-error mt-3 py-2 px-3 text-xs">{{ saveError() }}</div>
          }
        </div>

        <!-- List -->
        <div class="p-4 sm:p-6" style="min-height: 200px;">
          <h4 class="text-sm font-semibold text-white mb-4">Currently Linked Editors</h4>
          
          @if (isLoadingCreators()) {
            <div class="flex items-center justify-center py-8 text-[var(--text-muted)] text-sm">
              <svg class="animate-spin w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
              Loading editors...
            </div>
          } @else if (appCreators().length === 0) {
            <div class="text-center py-8 text-[var(--text-muted)] bg-[#ffffff02] border border-[#ffffff05] rounded-lg border-dashed">
              <svg class="w-8 h-8 mx-auto mb-2 opacity-30 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              <p class="text-xs">No editors linked yet.</p>
            </div>
          } @else {
            <div class="flex flex-col gap-2">
              @for (creator of appCreators(); track creator.user_id) {
                <div class="flex items-center justify-between p-3 rounded-lg border border-[#ffffff08] bg-[#ffffff03] hover:bg-[#ffffff05] transition-colors group">
                  <div class="flex items-center gap-3 min-w-0">
                    <div class="w-8 h-8 rounded-full bg-[#506ef7]/20 border border-[#506ef7]/30 flex items-center justify-center text-[#506ef7] font-semibold text-xs flex-shrink-0">
                      @if (canSeeOtherUsers() && appCreatorUsers()[creator.user_id]) {
                        {{ (appCreatorUsers()[creator.user_id].first_name?.charAt(0) ?? '') + (appCreatorUsers()[creator.user_id].last_name?.charAt(0) ?? '') || '?' }}
                      } @else {
                        ?
                      }
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-white truncate">
                        @if (canSeeOtherUsers() && appCreatorUsers()[creator.user_id]) {
                          {{ (appCreatorUsers()[creator.user_id].first_name ?? '') + ' ' + (appCreatorUsers()[creator.user_id].last_name ?? '') }}
                        } @else {
                          Linked editor
                        }
                      </div>
                      <div class="text-xs text-[var(--text-muted)] truncate flex items-center gap-1">
                        @if (canSeeOtherUsers() && appCreatorUsers()[creator.user_id]) {
                          {{ appCreatorUsers()[creator.user_id].email }}
                        } @else {
                          —
                        }
                      </div>
                    </div>
                  </div>
                  
                  @if (canManageCreators()) {
                  <button (click)="removeCreator(creator.user_id)" [disabled]="isSaving()" class="p-1.5 text-[var(--text-muted)] hover:text-red-400 hover:bg-red-400/10 rounded-md transition-colors flex-shrink-0 disabled:opacity-50" title="Remove Link">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                  </button>
                  }
                </div>
              }
            </div>
          }
        </div>
        } @else {
        <div class="py-12 px-6 text-center">
          <svg class="w-14 h-14 mx-auto mb-4 text-[var(--text-muted)] opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
          <p class="text-sm font-medium text-white">Sorry, you cannot see this feature.</p>
          <p class="text-xs text-[var(--text-muted)] mt-2 max-w-sm mx-auto">Content editor list and management are only available to Admin and Super Admin roles.</p>
        </div>
        }
      </div>
    </div>
  </div>
}

<!-- ======================================================================= -->
<!-- DELETE CONFIRMATION MODAL                                              -->
<!-- ======================================================================= -->
@if (showDeleteModal()) {
  <div class="modal-backdrop" (click)="closeDeleteModal()">
    <div class="modal-panel modal-panel--sm" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          <svg class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          Delete Application
        </h3>
        <button class="modal-close-btn" (click)="closeDeleteModal()">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="text-sm text-[var(--text-muted)] leading-relaxed">
          Are you sure you want to delete the application <strong class="text-white">{{ selectedApp()?.app_name }}</strong>? 
          This action cannot be undone and will permanently remove all access via this application.
        </p>

        @if (saveError()) {
          <div class="alert-error mt-4">{{ saveError() }}</div>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-ghost" (click)="closeDeleteModal()">Cancel</button>
        <button type="button" class="btn-danger" (click)="confirmDelete()" [disabled]="isSaving()">
          @if (isSaving()) {
            <svg class="animate-spin w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            Deleting...
          } @else {
            Delete App
          }
        </button>
      </div>
    </div>
  </div>
}
